import { PERFORM_REGISTER } from 'actions/register'

export default (state = null, action) => {
    switch (action.type) {
        case PERFORM_REGISTER:
            if (!!action.error) {
                return action.payload
            } else {
                return action.payload.data;
            }
    }

    return state;
}